export const CART_LIST_SORT = [
  {
    label: '',
    code: '',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.quantity',
    code: 'quantity',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.stock',
    code: 'stock',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.unit_price_ht',
    code: 'unit_price',
    direction: null,
    sortable: false,
  },
  {
    label: 'materiaux:messages:sort.ecopart',
    code: 'ecopart',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.amount_total_raw',
    code: 'amount_total_raw',
    direction: null,
    sortable: false,
  },
];

export const ORDERS_LIST_SORT = [
  {
    label: 'common:messages:sort.date',
    code: 'created_at',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.number',
    code: 'number',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.worksite',
    code: 'worksite',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.status',
    code: 'status',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.amount_total_raw',
    code: 'amount_total_raw',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.invoice',
    code: 'invoice',
    direction: null,
    sortable: false,
  },
  {
    label: null,
    code: 'detail',
    direction: null,
    sortable: false,
  },
];

export const ORDER_ITEMS_LIST_SORT = [
  {
    label: 'common:messages:sort.item',
    code: 'image',
    direction: null,
    sortable: false,
  },
  {
    label: null,
    code: 'label',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.manufacturer',
    code: 'product_brand',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.loyalty_points',
    code: 'loyalty_points',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.quantity',
    code: 'ordered_quantity',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.customer_price',
    code: 'price',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.total_line_amount',
    code: 'total_line_amount',
    direction: null,
    sortable: false,
  },
];

export const WORKSITES_LIST_SORT = [
  {
    label: 'common:messages:sort.date',
    code: 'creation_date',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.reference',
    code: 'label',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.name',
    code: 'address_name',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.city',
    code: 'address_city',
    direction: null,
    sortable: false,
  },
  {
    label: null,
    code: 'detail',
    direction: null,
    sortable: false,
  },
];

export const RETURN_LIST_SORT = [
  {
    label: null,
    code: 'image',
    direction: null,
    sortable: false,
  },
  {
    label: null,
    code: 'info',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.unit_price_ht',
    code: 'unit_price',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.return_quantity',
    code: 'quantity',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.motif',
    code: 'motif',
    direction: null,
    sortable: false,
  },
];

export const WISHLIST_LIST_SORT = [
  {
    label: '',
    code: 'image',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.quantity',
    code: 'quantity',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.stock',
    code: 'stock',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.unit_price_ht',
    code: 'unit_price',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.ecopart',
    code: 'ecopart',
    direction: null,
    sortable: false,
  },
  {
    label: 'common:messages:sort.amount_total_raw',
    code: 'amount_total_raw',
    direction: null,
    sortable: false,
  },
];
